<ngx-skeleton-loader
  *ngIf="itemsLoading$ | async; else itemsTable"
  count="2"
  appearance="line"
></ngx-skeleton-loader>
<ng-template #itemsTable>
  <app-workshop-jobs-table
    [currency]="currency"
    (print)="print($event)"
  ></app-workshop-jobs-table>
  <ng-container *ngIf="customerId$ | async as customerId">
    <app-customer-equipment-select
      [canAdd]="canAdd$ | async"
      [customerId]="customerId"
    ></app-customer-equipment-select>
  </ng-container>
</ng-template>
